/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { Auth } from 'aws-amplify';
import React,{useState} from 'react'
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';
import { logout } from '../../pages/auth/authSlice';
import { passwordCriteria } from '../../pages/auth/passwordCriteria';
import { userService } from '../../services/user.services';
import GlobalContext from '../Context/GloablContext';
import ErrorMessage from '../ErrorMessage';
import CommonModal from '../Modal';

export default function UpdatePassword() {
    const {setToastmessage,show, setshow} =useContext(GlobalContext)
    const dispatch=useDispatch()
    const auth = useSelector(state => state.auth);
    const location=useNavigate()
    const [password, setpassword] = useState('');
    const [Newpassword, setNewpassword] = useState('');
    const [autoGeneratedPassword, setautoGeneratedPassword] = useState('');
    const [submitSelected, setsubmitSelected] = useState(false);
    const [type, settype] = useState('password');
    const [AutoType, setAutoType] = useState('password');
    const [ConfirmType, setConfirmType] = useState('password');


    const [loading, setloading] = useState(false)
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$])[a-zA-Z\d!@#$]{8,}$/;
    const [OverallError, setOverallError] = useState('')
    const [invalidAutoPassword, setinvalidAutoPassword] = useState('')
    // useEffect(() => {
    //     if(auth.email===''){
    //         location('/')
    //     }
    // }, [])
    const handleClose=()=>{
        setsubmitSelected(false)
        setpassword('')
        setNewpassword('')
        setautoGeneratedPassword('')

        setshow(false)
    }
    const handleSubmit=async(e)=>{
        e.preventDefault()
        setsubmitSelected(true);
        setOverallError('')
        setloading(true)
        if(autoGeneratedPassword===''||password===''||Newpassword===''){
            setloading(false)
            return;
        }
        // if(!passwordRegex.test(password)){
        //     setloading(false)
        //     return;
        // }

        const payload={
            "confirm_password":password,
            "new_password": Newpassword,
            "old_password": autoGeneratedPassword
            
        }
        const email = localStorage.getItem('email');
        const ResetResponse = await userService.resetPassword(email,payload);
        if(ResetResponse.data.success_status){
            setToastmessage('Password updated successfully');
            localStorage.clear();
            setshow(false)
            Auth.signOut()
            dispatch(logout())

            
        }else{
            if(ResetResponse.data.message==='Invalid auto-generated password. Please check and try again'){
                setinvalidAutoPassword(ResetResponse.data.message)
            }else{
                setOverallError(ResetResponse.data.message)

            }
            setloading(false)
        }

    }


    return (
    // <div data-te-modal-init className="fixed left-0 top-0 z-[1055] show h-full w-full overflow-y-auto overflow-x-hidden outline-none"
    //     id="exampleModalCenter" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-modal="true" role="dialog">
    //     <div data-te-modal-dialog-ref className="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[415px] max-w-[415px] mx-auto">
    //         <div className="pointer-events-auto relative flex w-full flex-col rounded-lg border-none bg-white bg-clip-padding shadow-s5 outline-none dark:bg-neutral-600 px-[36px] py-[24px]">
    //             <div className="flex items-center justify-between">
    //                 <h5 className="text-2xl font-bold text-[#031624]   relative updatepassword">Update Password</h5>
    //                 <button type="button" className="opacity-60 hover:opacity-80 focus:opacity-100 focus:shadow-none focus:outline-none" data-te-modal-dismiss
    //                     aria-label="Close">
    //                     <span>
    //                         <img loading="lazy" decoding="async" src="/images/modalClose.svg" alt="icon" />
    //                     </span>
    //                 </button>
    //             </div>
                    
        //         </div>
        //     </div>
        // </div>
        <CommonModal 
            title="Update Password" 
            handleClose={handleClose}
            show={show} 
            setshow={setshow}>
            <form onSubmit={(e)=>handleSubmit(e)} className="mt-5">
                <div className="flex flex-col">
                    <label for="autoPassWord" className="text-f1 font-medium text-[#344054] pb-1.5">Current Password</label>
                    <div className="relative">
                        <input 
                            type={AutoType}
                            onFocus={()=>{
                                setsubmitSelected(false);
                                setOverallError('')
                                setinvalidAutoPassword('')

                            }}
                            value={autoGeneratedPassword}
                            id="autoPassWord" 
                            style={{border:`1px solid ${submitSelected &&autoGeneratedPassword===''||invalidAutoPassword!==''?'#FDA29B':'#D0D5DD'}`}}
                            onChange={(e)=>setautoGeneratedPassword(e.target.value)}
                            className="err-border w-full border border-[#D0D5DD] rounded-lg py-2.5 pl-3.5 pr-[39px] outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828]" 
                            autocomplete="off" 
                            placeholder="Enter Password" />
                        <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-3.5">
                            {AutoType==='text'?<img loading="lazy" src="/images/eye-open.svg" alt="password-show" className="password-show" onClick={()=>setAutoType('password')} />
                                :<img loading="lazy" src="/images/eye-closed.svg" alt="password-hide" className="password-show" onClick={()=>setAutoType('text')}/>}
                        </button>
                    </div>
                    <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError hidden">Current password is mandatory</p>
                    <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err1 hidden">Current password is incorrect</p>
                    {submitSelected &&invalidAutoPassword !=='' && <ErrorMessage 
                        error 
                        message={"Current password is incorrect"}
                        classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"/>}
                    {submitSelected &&autoGeneratedPassword ==='' && <ErrorMessage 
                        error 
                        message={"Current password is mandatory"}
                        classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"/>}

                </div>
                <div className="flex flex-col mt-4">
                    <label for="newPassword" className="text-f1 font-medium text-[#344054] pb-1.5">New Password</label>
                    <div className="relative">
                        <input 
                            type={type}
                            onChange={(e)=>setpassword(e.target.value)} 
                            value={password} 
                            id="newPassword" 
                            style={{border:`1px solid ${submitSelected &&password===''?'#FDA29B':'#D0D5DD'}`}}
                            onFocus={()=>{
                                setsubmitSelected(false);
                                setOverallError('')
                                setinvalidAutoPassword('')

                            }}
                            className="err-border w-full border border-[#D0D5DD] rounded-lg py-2.5 pl-3.5 pr-[39px] outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828]" autocomplete="off" placeholder="Enter Password" />
                        <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-3.5">
                            {type==='text'?<img loading="lazy" src="/images/eye-open.svg" alt="password-show" className="password-show" onClick={()=>settype('password')} />
                                :<img loading="lazy" src="/images/eye-closed.svg" alt="password-hide" className="password-show" onClick={()=>settype('text')}/>}
                        </button>
                    </div>
                    <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err hidden">New password is mandatory</p>
                    {submitSelected &&password==='' && <ErrorMessage 
                        error 
                        message={"New password is mandatory"}
                        classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                    />}
                                        

                                        
                </div>
                <p className="text-f1 font-normal text-[#667085] pt-1.5">Please make sure your password includes the following:</p>
                <ul className="mt-4 pl-2">
                    {Object.keys(passwordCriteria).map((criteria)=>(
                        <li className="flex items-center mb-1" key={criteria}>
                            <span>
                                <img src={!passwordCriteria[criteria]["regex"].test(password)?`/images/login-bulletPOint.svg`:`/images/otp-tick.svg`} alt="img" loading="lazy" className="password-weak" id={criteria} />
                            </span>
                            <span className="text-f1 font-normal text-[#667085] pl-[11px]"> {criteria}</span>
                        </li>
                    ))}
                </ul>
                <div className="flex flex-col mt-[26px]">
                    <label for="ConformNewPassword" className="text-f1 font-medium text-[#344054] pb-1.5">Confirm New Password</label>
                    <div className="relative">
                        <input 
                            type={ConfirmType} 
                            onChange={(e)=>setNewpassword(e.target.value)} 
                            style={{border:`1px solid ${(submitSelected &&Newpassword==='' || Newpassword?.length>0&& Newpassword!==password)?'#FDA29B':'#D0D5DD'}`}}
                            value={Newpassword}
                            onFocus={()=>{
                                setsubmitSelected(false);
                                setOverallError('')
                                setinvalidAutoPassword('')

                            }}
                            id="ConformNewPassword" 
                            className="err-border w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828]" 
                            autocomplete="off"
                            placeholder="Enter Password" />
                        <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-3.5">
                            {ConfirmType==='text'?<img src="/images/eye-open.svg" loading="lazy" alt="password-show" className="password-show" onClick={()=>setConfirmType('password')} />
                                :<img src="/images/eye-closed.svg" alt="password-hide" className="password-show" onClick={()=>setConfirmType('text')}/>}
                        </button>
                    </div>
                </div>
                <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError hidden">Confirm password is mandatory</p>
                {submitSelected &&Newpassword==='' && <ErrorMessage 
                    error 
                    message={"Confirm password is mandatory"}
                    classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"/>}
                {Newpassword?.length>0&&password!==Newpassword && <ErrorMessage 
                    error 
                    message={"New password and confirm password do not match."}
                    classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                />}
                {OverallError!=='' && <ErrorMessage 
                    error 
                    message={OverallError}
                    classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                />}
                <button 
                    type="submit"
                    id="resetpwd-form"
                    disabled={(password!==Newpassword ||loading)}
                    className=" flex justify-center items-center w-full bg-[#106EB4] py-3 rounded mt-5 text-f2 font-normal text-[#ffffff] ltr-spcng-8 hover:bg-[#1C8ADC] hover:duration-75">
                    {!loading?'Update':<span>{<Loader />}</span>}
                </button>
            </form>
        </CommonModal>
    )
}
    
